import React from 'react';
import { Divider as StyledDivider } from './Divider.styled';

export interface DividerProps {
  className?: string;
}

export function Divider({ className }: DividerProps) {
  return <StyledDivider className={className} />;
}
